module.exports = __webpack_public_path__ + "media/images/app_mrkun-8b9b81671b5771f6f41523e8df99b8ad.png";